<!--begin::Body-->
<div class="d-flex flex-column flex-center mt-30 mt-lg-0 height-100 password-container">
  <div class="login-form login-signin">
    <div class="text-center mb-10">
      <h3 class="font-size-h1">Descargar Pdf</h3>
      <div class="btn btn-primary font-weight-bold text-uppercase px-9 py-4 mr-2"
           data-wizard-type="action-submit" (click)="downloadPdf()">
        Descargar
      </div>
    </div>
  </div>
  <div class="company-info">
    <div class="mb-5 d-flex justify-content-center">
      <a href="https://twitter.com/AsegurateColombia" target="_blank">
        <img src="../../../../assets/media/logos/twitter.png" alt="twitter">
      </a>
      <a href="https://www.facebook.com/Aseguratecolombia/" target="_blank">
        <img src="../../../../assets/media/logos/facebook.png" alt="facebook" style="margin-left: 7px;">
      </a>
      <a href="https://linkedin.com/company/Asegurate-s-a-s/" target="_blank">
        <img src="../../../../assets/media/logos/linkedin.png" alt="linkedin" style="margin-left: 7px;">
      </a>
    </div>
    <p class="text-muted font-weight-bold text-justify">Teléfono: (+57 1) 255 9532 | Celular: (+57) 318 706 8636 |
      Dirección: Calle 71A # 17 – 35 Of. 303 Bogotá - Colombia | contacto@aseguratelimitada.com | <a
        href="http://www.aseguratelimitada.com/" target="_blank">www.aseguratelimitada.com</a></p>
  </div>
</div>

